import httpClient from 'api/httpClient';
import { NotificationType, NotificationGroup } from 'models/Notification';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';

const getNotifications = (
  params: PaginationParams & {
    isRead?: boolean;
    dataRoomId?: string;
    group: NotificationGroup;
  },
) => {
  return httpClient.get<PaginatedData<NotificationType>>('/notifications', {
    params,
  });
};

const readAllNotifications = () => {
  return httpClient.post<NotificationType>('/notifications/read-all');
};

const readNotification = (notificationId: string) => {
  return httpClient.post<NotificationType>(
    `/notifications/${notificationId}/read`,
  );
};

const unreadNotification = (notificationId: string) => {
  return httpClient.post<NotificationType>(
    `/notifications/${notificationId}/unread`,
  );
};

const getUnreadNotifications = (params: { dataRoomId?: string }) => {
  return httpClient.get<{
    allNotificationsCount: number;
    unreadNotificationsCount: number;
  }>(`/notifications/unread-notifications`, {
    params,
  });
};

const deleteNotification = (notifId: string) => {
  return httpClient.delete(`/notifications/${notifId}`);
};

export default {
  getNotifications,
  readAllNotifications,
  readNotification,
  unreadNotification,
  getUnreadNotifications,
  deleteNotification,
};
